import React from 'react';
import * as Sentry from '@sentry/react';


interface SentryErrorBoundaryProps {
  children: React.ReactNode;
  showDialog?: boolean;
}

const onErrorHandler = (error: any, info: string) => {
  Sentry.captureException(error);
};

// ErrorBoundary con Sentry integrado
const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ 
  children,
}) => {
  return (
    <Sentry.ErrorBoundary onError={onErrorHandler}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary; 